export const isMongoId = (item: string) => /^[0-9a-fA-F]{24}$/.test(item);